'use client';

import React from 'react';
import type { IconButtonProps } from '@chakra-ui/react';
import { IconButton } from '@chakra-ui/react';
import LucideIcon from '@/components/ui/LucideIcon';

type ScrollDirection = 'left' | 'right';

interface ScrollButtonProps extends Omit<IconButtonProps, 'aria-label'> {
  direction: ScrollDirection;
  isVisible: boolean;
  onClick: () => void;
  isScrolling: boolean;
}

const ScrollButton = ({ direction, isVisible, onClick, isScrolling, ...rest }: ScrollButtonProps) => {
  const iconName = direction === 'left' ? 'ChevronLeft' : 'ChevronRight';

  return (
    <IconButton
      aria-label={`Scroll ${direction}`}
      onClick={onClick}
      zIndex={2}
      borderRadius="50%"
      backgroundColor="common.100"
      color="brand.40"
      size="sm"
      justifyContent="center"
      borderWidth="2px"
      borderColor="brand.40"
      display={{ base: 'none', desktop: isVisible ? 'flex' : 'none' }}
      disabled={isScrolling}
      position="absolute"
      top="50%"
      transform="translateY(-50%)"
      left={direction === 'left' ? 0 : undefined}
      right={direction === 'right' ? 0 : undefined}
      {...rest}
    >
      <LucideIcon name={iconName} boxSize={6} />
    </IconButton>
  );
};

export default ScrollButton;
